import { FormControlLabel, Switch, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";

export default () => {
	return (
		<CssColumnGrid columns={4}>
			<Text semiBold text="start" />
			<Text semiBold text="end (default)" />
			<Text semiBold text="top" />
			<Text semiBold text="bottom" />
			<FormControlLabel
				control={<Switch checked={false} />}
				label="Label"
				labelPlacement="start"
			/>
			<FormControlLabel
				control={<Switch checked={false} />}
				label="Label"
				labelPlacement="end"
			/>
			<FormControlLabel
				control={<Switch checked={false} />}
				label="Label"
				labelPlacement="top"
			/>
			<FormControlLabel
				control={<Switch checked={false} />}
				label="Label"
				labelPlacement="bottom"
			/>
		</CssColumnGrid>
	);
};